module.exports = __webpack_public_path__ + "img/semi-trailer.ac802d5.png";